module.exports = __webpack_public_path__ + "img/s1-2.f3f6675c.jpg";